/**
 * @param {import("../../../../utils/router/Router").default} router
 */
export default function (router) {
  router.group(
    {
      path: "/alfred/hotels/appointments",
    },
    (router) => {
      router.push({
        id: "@api/hotel.appointment@search",
        path: "",
      });

      router.push({
        id: "@api/hotel.appointment@create",
        path: "",
      });

      router.group(
        {
          path: "/:hotelAppointmentId",
        },
        (router) => {
          router.push({
            id: "@api/hotel.appointment@view",
            path: "",
          });

          router.push({
            id: "@api/hotel.appointment@update",
            path: "",
          });

          router.push({
            id: "@api/hotel.appointment@delete",
            path: "",
          });

          router.group(
            {
              path: "/action",
            },
            (router) => {
              router.push({
                id: "@api/hotel.appointment@confirm",
                path: "/confirm",
              });

              router.push({
                id: "@api/hotel.appointment@cancel",
                path: "/cancel",
              });
            },
          );
        },
      );
    },
  );
}
